import React from 'react'
import { Col, Row } from 'reactstrap'

import { BooleanStaticField, NumberStaticField, StaticField } from 'common/components/StaticField'
import { StaticRow } from 'common/components/StaticRow'
import { currencyFormatter } from 'common/utils'

import { AdviceRequest } from '../../../interfaces'
import PartnerData from '../images/antragsdaten.svg'

import './DevkView.scss'

interface DEVKViewProps {
  adviceRequest: AdviceRequest
}

export const DevkView = ({ adviceRequest }: DEVKViewProps): JSX.Element => (
  <StaticRow>
    <Col md={12} className="devk-view  m-b-20">
      <PartnerData width="18" height="20" className="m-r-10" />
      <h3 className="h3 small">DEVK-Falldaten</h3>
      <Row className="m-l-5 m-r-10">
        <Col md={12}>
          <StaticField label="Schadensnummer" value={adviceRequest.damageNumber || '-'} />
        </Col>
        <Col md={3}>
          <NumberStaticField label="Streitwert in €" value={adviceRequest.disputeAmount || '-'} />
        </Col>
        <Col md={3}>
          {adviceRequest.deductible ? (
            <NumberStaticField
              label="Höhe der Selbstbeteiligung"
              value={adviceRequest.deductibleAmount}
              formatter={currencyFormatter}
            />
          ) : (
            <BooleanStaticField label="Höhe der Selbstbeteiligung" value={adviceRequest.deductible} />
          )}
        </Col>
        <Col md={3}>
          {!adviceRequest.noProtection ? (
            <StaticField
              label="Umfang Kostenschutz"
              value={
                // [13.07.23] Temporal solution until DB migration for adviceRequest.protectionAmount in all envs
                Array.isArray(adviceRequest.protectionAmount)
                  ? adviceRequest.protectionAmount.join(', ')
                  : adviceRequest.protectionAmount || '-'
              }
            />
          ) : (
            // Double negation to avoid changing user feedback after Data change
            <BooleanStaticField label="Umfang Kostenschutz" value={!adviceRequest.noProtection} />
          )}
        </Col>
      </Row>
    </Col>
  </StaticRow>
)
